import { render, staticRenderFns } from "./EmptyFolder.vue?vue&type=template&id=6a01d646&scoped=true&"
import script from "./EmptyFolder.vue?vue&type=script&lang=js&"
export * from "./EmptyFolder.vue?vue&type=script&lang=js&"
import style0 from "./EmptyFolder.vue?vue&type=style&index=0&id=6a01d646&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a01d646",
  null
  
)

export default component.exports